import { render, staticRenderFns } from "./CompanySearch.vue?vue&type=template&id=ff4d6e00&scoped=true&"
import script from "./CompanySearch.vue?vue&type=script&lang=js&"
export * from "./CompanySearch.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=ff4d6e00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff4d6e00",
  null
  
)

export default component.exports